export default __webpack_public_path__ + "static/media/flag_mex.09e52241.svg";